var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"18px","padding":"20px","word-break":"break-all"}},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("FM page not found")]),_c('div',[_vm._v(_vm._s(_vm.href))]),_c('br'),_c('a',{attrs:{"href":"/"}},[_vm._v("回到主页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }